<template>
  <div>
    <v-data-table
      dense
      multi-sort
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn rounded small @click="refresh" color="accent">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-4" inset></v-divider>
          <v-btn small color="primary" rounded @click="openItemDialog" :disabled="!filesUserId">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item._id="{ item }">
        <span style="display: inline-block; width: 50px" class="text-truncate" :title="item._id">
          {{ item._id }}
        </span>
      </template>
      <template v-slot:item.user_id="{ item }">
        {{ item.user_id ? item.user_id.firstName : 'N/A' }} {{ item.user_id ? item.user_id.lastName : 'N/A' }}
      </template>
      <template v-slot:item.forUser="{ item }">
        {{ item.forUser ? item.forUser.firstName : 'N/A' }} {{ item.forUser ? item.forUser.lastName : 'N/A' }}
      </template>
      <template v-slot:item.url="{ item }">
        <a :href="SERVER_URL + item.url" download target="_blank" class="text-decoration-none">
          <v-icon color="primary">mdi-download</v-icon>
        </a>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            color="accent"
            title="editeaza fisier">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(item)"
            color="error"
            title="sterge fisier">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
      </template>
    </v-data-table>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Adaugare' : 'Modificare' }} Fisier</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-text-field
              v-model="item.title"
              label="Titlu"
              hint="Titlu fisier"
              :rules="[rules.required]">
            </v-text-field>
            <v-textarea
              label="Descriere"
              v-model="item.description"
              hint="Descriere fisier"
              :rules="[rules.required]">
            </v-textarea>
            <v-file-input
              v-model="item.buffer"
              label="Fisier"
              ref="fileField"
              hint="Click pentru a incarca un fisier"
              :prepend-icon="null"
              :rules="[itemAction === 'add' ? rules.required : () => true]">
            </v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-alert type="error" v-if="message" dismissible @input="alertChanged">{{ message }}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Inchide</v-btn>
          <v-btn color="primary" @click="saveItem">Salveaza Status</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Confirmati stergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anuleaza stergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Sterge Fisier</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'ReviewerUploadsComponent',

  data: () => ({
    SERVER_URL,
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'incarcat de',
        value: 'user_id',
        align: 'left',
        sortable: false,
        filterable: false
      },
      {
        text: 'incarcat pentru',
        value: 'forUser',
        align: 'left',
        sortable: false,
        filterable: false
      },
      {
        text: 'denumire',
        value: 'title',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'descriere',
        value: 'description',
        align: 'left',
        sortable: true,
        filterable: true
      },
      {
        text: 'data',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'tip',
        value: 'type',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'link',
        value: 'url',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'actiuni',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    item: {
      _id: null,
      title: null,
      description: null,
      dataType: 'review',
      buffer: null
    },
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,
    rules: {
      required: val => !!val || 'Campul nu poate fi gol!'
    },
    message: null
  }),

  computed: {
    items () {
      return this.$store.getters.filesItems
    },
    options: {
      get () {
        return this.$store.getters.filesOptions
      },
      set (value) {
        this.$store.dispatch('setFilesOptions', value)
      }
    },
    totalItems () {
      return this.$store.getters.filesTotal
    },
    loading () {
      return this.$store.getters.filesLoading
    },
    filesUserId () {
      return this.$store.getters.filesUserId
    }
  },

  methods: {
    refresh () {
      this.$store.dispatch('fetchFiles')
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
      this.message = null
    },
    openItemDialog () {
      this.itemForm = true
      this.itemAction = 'add'
    },
    async saveItem () {
      const valid = this.$refs.form.validate()
      if (valid) {
        const payload = Object.assign({}, this.item)
        const result = await this.$store.dispatch('saveFile', payload)
        if (result === true) {
          this.closeItemDialog()
        } else {
          this.message = 'Ne pare rau. A aparut o eroare la procesarea cererii...'
        }
      }
    },
    editItem (item) {
      this.item._id = item._id

      this.item.title = item.title
      this.item.description = item.description

      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteFile', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    alertChanged ($event) {
      if (!$event) this.message = null
    }
  }
}

const defaultItem = {
  _id: null,
  title: null,
  description: null,
  dataType: 'review',
  buffer: null
}
</script>
